const UsersIndex = () => import('./users/index.vue');
const CreatePage = () => import('./users/_pages/create.vue');
const EditPage = () => import('./users/_pages/view.vue');
const EditPasswordPage = () => import('./users/_pages/password.vue');

// user groups 
const UserGroup = () => import('./groups/index.vue');
const CreateUserGroup = () => import('./groups/_pages/create.vue');
const EditUserGroup = () => import('./groups/_pages/view.vue');

// employees
const EmployeesIndex = () => import('./employees/index.vue');
const CreateEmployeePage = () => import('./employees/_pages/create.vue');
const EditEmployeePage = () => import('./employees/_pages/view.vue');



export default [
    {
        path: '/employees',
        component: EmployeesIndex
    },
    {
        path: '/new-employee',
        component: CreateEmployeePage
    },
    {
        path: '/employees/:id',
        component: EditEmployeePage
    },
    {
        path: '/users',
        name: 'Users',
        component: UsersIndex
    },
    {
        path: '/new-user',
        component: CreatePage
    },
    {
        path: '/edit-user/:id',
        component: EditPage
    },
    {
        path: '/edit-user/password/:id',
        component: EditPasswordPage
    },
    {
        path: '/user-groups',
        component: UserGroup
    },
    {
        path: '/new-user-group',
        component: CreateUserGroup
    },
    {
        path: '/edit-user-group/:id',
        component: EditUserGroup
    }
]
    
